import { useEffect, useState } from "react";
import { ethers } from "ethers";
import ERC20ABI from "../abi/ERC20ABI.json";


export const useTokenName = (provider: ethers.ContractRunner | null | undefined, tokenAddress: any) => {
    //   const [totalHolers, setTotalHolers] = useState(0);
    const [name, setName] = useState("");


    useEffect(() => {
        const getTotal = async () => {
            const tokenContract = new ethers.Contract(
                tokenAddress || "",
                ERC20ABI.abi,
                provider
            );

            //   const res = await tokenContract.getTotalHolders();
            //   setTotalHolers(Number(res));

            const tokenName = await tokenContract.name();
            setName(tokenName);
        };

        getTotal().catch(console.error);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return name;
};
